import { apiCall } from "../../../services/api-service";

export const getVehicleDetailAPI = (id) =>
  apiCall("get", `get_vehicle_details/${id}`);

export const addAttachmentApi = (id, body) =>
  apiCall("put", `km_history/add_attachment/${id}`, body);

export const getKmHistDetAPI = (id) =>
  apiCall("get", `km_history/${id}`);

export const submitAPI = (body) =>
  apiCall("post", "km_history", body);

export const UpdateAPI = (body, id) =>
  apiCall("put", `km_history/${id}`, body);

